import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Spinner from '../Spinner/Spinner'

import styles from './Processing.css'

const propTypes = {
    type: PropTypes.oneOf(['fullscreen', 'window', 'gamefield', 'local']),
    caption: PropTypes.node,
    isVisible: PropTypes.bool,
}

class Processing extends React.PureComponent {
    render() {
        const classNameBase = classNames(styles.base, {
            [styles[`base__${this.props.type}`]]: this.props.type,
            [styles.isVisible]: this.props.isVisible,
        })

        return (
            <div className={classNameBase}>
                <div className={styles.spinner}>
                    <Spinner caption={this.props.caption} />
                </div>
            </div>
        )
    }
}

Processing.propTypes = propTypes

export default Processing



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Processing/Processing.jsx